import { AVATAR_COLORS } from 'src/constants/global'

import './AvatarPlaceholder.css'
interface AvatarPlaceholderProps {
  text: string
  className?: string
}

export default function AvatarPlaceholder({
  text,
  className = ''
}: AvatarPlaceholderProps) {
  const seed = text || '?'

  const getColor = (str: string) => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    const index = Math.abs(hash % AVATAR_COLORS.length)
    return AVATAR_COLORS[index]
  }

  const backgroundColor = getColor(seed)
  const displayChar = seed[0].toUpperCase()

  return (
    <div
      className={`avatar-placeholder ${className}`}
      style={{ backgroundColor }}
    >
      <span>{displayChar}</span>
    </div>
  )
}
